// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p55n","controls":"styles_controls__3xFR4","charLimit":"styles_charLimit__lj6UO","input":"styles_input__11sHY","send":"styles_send__MTjWf"};